export const containsEndInterviewPhrases = (transcript) => {
  if (!transcript || typeof transcript !== "string") return false;

  const endPhrases = [
    // End interview
    "end the interview",
    "end this interview",
    "end interview",
    "please end the interview",
    "can we end the interview",
    "can you end the interview",
    "please end it",
    "end it",
    "that's all",

    // Finish
    "finish the interview",
    "finish this interview",
    "finish interview",
    "let's finish",
    "we can finish",
    "i am done",
    "i'm done",
    "i have finished",
    "i've finished",
    "i'm finished",
    "done",
    "finished",

    // Stop
    "stop the interview",
    "stop this interview",
    "stop interview",
    "stop it",
    "please stop",
    "can we stop",
    "can you stop",
    "stop now",

    // Close
    "close the interview",
    "close this interview",
    "close interview",
    "close the assessment",
    "close assessment",

    // Conclude
    "conclude the interview",
    "conclude this interview",
    "let's conclude",
    "conclude it",

    // Wrap up
    "wrap up the interview",
    "wrap up this interview",
    "wrap it up",
    "let's wrap up",
    "wrap up",

    // Terminate
    "terminate the interview",
    "terminate this interview",

    // Exit
    "exit the interview",
    "exit interview",
    "quit the interview",
    "quit interview",
    "leave the interview",
    "leave interview",

    // End assessment
    "end the assessment",
    "end assessment",
    "finish the assessment",
    "finish assessment",
    "stop the assessment",
    "stop assessment",

    // No more questions
    "no more questions",
    "i have nothing more to say",
    "nothing else",
    "that's everything",
    "that's it",
    "that's all from my side",
    "i'm good",
    "we're done",
    "i think that's all",
    "that is all",

    // Thank you + ending
    "thank you that's all",
    "thank you i am done",
    "thank you we can end",
    "thanks that's all",
    "thanks i am done",
    "thanks",

    // Unable to answer
    "i don't know",
    "i dont know",
    "i have no idea",

    "i'm not sure",
    "i am unsure",
    "i am unsure about that",
    "i am not aware",
    "i cannot answer",
    "i can't answer",
    "i don't have an answer",
    "i don't know the answer",
    "i don't have that information",
    "i am not familiar with that",
    "i am not certain",
    "i am not positive about that",
    "i am not too sure",
    "yes, please proceed",
    "please proceed",
    "all right",
    "i am not exactly sure",
    "i am not quite sure",
    "i am not really sure",
    "i am not entirely sure",
    "i am not completely sure",
    "i am not 100% sure",
    "i am not 100 percent sure",
    "i am not sure about that",
    "i am not sure",
    "i have no clue",

    "i don’t know",
    "i can't say for sure",
    "i don’t have that information",
    "thank you",
  ];

  const lowerTranscript = transcript.toLowerCase().trim();

  return endPhrases.some((phrase) => lowerTranscript.includes(phrase));
};
